import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { ActivatedRoute, Router } from '@angular/router';
import { Acesso } from 'src/app/core/acesso';
import { CarregarPerfil } from 'src/app/core/carregar-perfil';
import { PlanosContas } from 'src/app/core/planos-contas';
import { PublicoAlvo } from '../../core/publico-alvo';
import { PublicoAlvoService } from '../../services/publico-alvo/publico-alvo.service';
import { ConfirmDialogComponent } from '../common/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'publico-alvo',
  templateUrl: './publico-alvo.component.html',
  styleUrls: ['./publico-alvo.component.css']
})
export class PublicoAlvoComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  listaPublicosAlvos: PublicoAlvo[];
  mostrarTabela: boolean = false;
  publicoAlvo: PublicoAlvo = new PublicoAlvo();
  msg: string;

  displayedColumns: string[] = ['descricao', 'acoes'];
  dataSource: MatTableDataSource<PublicoAlvo> = new MatTableDataSource();
  
  perfilAcesso: Acesso = new Acesso();
  carregarPerfil: CarregarPerfil  = new CarregarPerfil();
  planosContas: PlanosContas[];

  constructor(
    private publicoAlvoService: PublicoAlvoService,
    private router: Router,
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.carregarPerfil.carregar(this.activatedRoute.snapshot.data.perfilAcesso, this.perfilAcesso);
    this.dataSource.paginator = this.paginator;
    this.getAll();
  }


  limpar() {
    this.mostrarTabela = false;
    this.publicoAlvo = new PublicoAlvo()
    this.dataSource.data = [];
  }

  consultar() {
    if (this.publicoAlvo.id) {
      this.publicoAlvoService.getById(this.publicoAlvo.id).subscribe((publicoAlvo: PublicoAlvo) => {
        if (!publicoAlvo) {
          this.mostrarTabela = false
          this.msg = "Nenhum registro para a pesquisa selecionada"
        } else {
          this.dataSource.data = [publicoAlvo];
          this.mostrarTabela = true;
        }
      },
        (retorno) => {
          this.mostrarTabela = false
          this.msg = retorno.error.mensagem
        }
      )
    } else {
      this.getAll();
    }

  }


  atualizar(publicoAlvo: PublicoAlvo) {
    this.router.navigate(['/publicosalvos/cadastrar'], { queryParams: { id: publicoAlvo.id } });
  }

  deletar(publicoAlvo: PublicoAlvo) {
    this.chamaCaixaDialogo(publicoAlvo);
  }

  chamaCaixaDialogo(publicoAlvo: PublicoAlvo) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      pergunta: `Certeza que deseja excluir ?`,
      textoConfirma: 'SIM',
      textoCancela: 'NÃO'
    };

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(confirma => {
      if (confirma) {
        this.publicoAlvoService.excluir(publicoAlvo.id).subscribe(() => {
          this.publicoAlvo.id = null;
          this.consultar();
        })

      } else {
        dialogRef.close();
      }
    }
    );
  }

  getAll() {
    this.publicoAlvoService.getAll().subscribe((listaPublicosAlvos: PublicoAlvo[]) => {
      this.listaPublicosAlvos = listaPublicosAlvos;
      this.dataSource.data = listaPublicosAlvos ? listaPublicosAlvos : [];
      this.verificaMostrarTabela(listaPublicosAlvos);
    })
  }

  verificaMostrarTabela(listaPublicosAlvos: PublicoAlvo[]) {
    if (!listaPublicosAlvos || listaPublicosAlvos.length == 0) {
      this.mostrarTabela = false;
      this.msg = "Nenhum público alvo cadastrado."
    } else {
      this.mostrarTabela = true;
    }
  }

}
